import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Skeleton — loading placeholder block. Size it with width/height utilities:
 *
 *   <Skeleton className="tw-h-4 tw-w-40" />
 *   <Skeleton lines={3} />            // paragraph of shimmering lines
 *   <Skeleton circle className="tw-h-8 tw-w-8" />
 */
const Skeleton = ({ lines, circle, className }) => {
  if (lines > 1) {
    return (
      <div className="tw-flex tw-flex-col tw-gap-2" aria-hidden>
        {Array.from({ length: lines }, (_, i) => (
          <div
            key={i}
            className={classNames(
              'tw-animate-pulse tw-bg-slate-200 tw-rounded tw-h-3.5',
              i === lines - 1 ? 'tw-w-2/3' : 'tw-w-full',
              className
            )}
          />
        ))}
      </div>
    );
  }

  return (
    <div
      aria-hidden
      className={classNames(
        'tw-animate-pulse tw-bg-slate-200',
        circle ? 'tw-rounded-full' : 'tw-rounded',
        className
      )}
    />
  );
};

Skeleton.propTypes = {
  lines: PropTypes.number,
  circle: PropTypes.bool,
  className: PropTypes.string
};

Skeleton.defaultProps = {
  lines: 1,
  circle: false
};

export default Skeleton;
